module.exports = __webpack_public_path__ + "img/Arjun Dewan, Co-Director of Marketing, S.51ec9029.webp";